import { Button, DatePicker, Modal } from 'antd';
import locale from 'antd/es/date-picker/locale/ko_KR';
import moment from 'moment';
import 'moment/locale/ko';
import React, { useEffect, useState } from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import * as XLSX from 'xlsx';
import { httpPost, httpUrl } from '../../api/httpClient';
import Const from '../../const';
import { categoryCode, modalErrorStyle } from '../../lib/util/codeUtil';
import { comma } from '../../lib/util/numberUtil';
import Pagination from '../input/Pagination';
import image from '../../res/image';

const { RangePicker } = DatePicker;
const dateFormat = 'YYYY-MM-DD';
const dateTimeFormat = 'YYYY-MM-DD HH:00:00';
const now = new Date();
const now2 = new Date();
const PagedListSize = 9;

const dailyHeader = [
  {
    statDateStr: '일시',
    cntOrderAll: '총건수',
    cntOrderCompleted: '총완료건수',
    // cntPaymentAll: "총결제건수",
    // cntPaymentCompleted: "총완료결제건수",
    sumDeliveryPrice: '총배달금액',
    sumOrderPrice: '총주문금액',
    cntCard: '카드건수',
    sumCard: '카드금액',
    cntCash: '현금건수',
    sumCash: '현금금액',
    cntPrepayed: '선결건수',
    sumPrepayed: '선결금액',
  },
];
const monthlyHeader = [
  {
    statMonthStr: '일시',
    cntOrderAll: '총건수',
    cntOrderCompleted: '총완료건수',
    // cntPaymentAll: "총결제건수",
    // cntPaymentCompleted: "총완료결제건수",
    sumDeliveryPrice: '총배달금액',
    sumOrderPrice: '총주문금액',
    cntCard: '카드건수',
    sumCard: '카드금액',
    cntCash: '현금건수',
    sumCash: '현금금액',
    cntPrepayed: '선결건수',
    sumPrepayed: '선결금액',
  },
];

const defKindType = {
  daily: 1,
  monthly: 2,
};

const DeliveryStatic = () => {
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 9,
    startDate: moment(now).add(-6, 'M'),
    endDate: now,
    //startDate: moment(now.setHours(reactLocalStorage.getObject(Const.appName + "#calculateHour"))).add(-6, "M"),
    //endDate: moment(now.setHours(reactLocalStorage.getObject(Const.appName + "#calculateHour"))),
  });
  const [list, setList] = useState([]);
  const [total, setTotal] = useState(0);
  const [selectOpen, setSelectOpen] = useState(false);
  const [selectCategory, setSelectCategory] = useState(
    Object.keys(categoryCode)
  );

  const [kind, setKind] = useState(defKindType.daily);
  var object = {
    statDateStr: moment(now).format(dateFormat),
    cntOrderAll: 0,
    cntOrderCompleted: 0,
    cntPaymentAll: 0,
    cntPaymentCompleted: 0,
    sumDeliveryPrice: 0,
    sumOrderPrice: 0,
    cntCard: 0,
    sumCard: 0,
    cntCash: 0,
    sumCash: 0,
    cntPrepayed: 0,
    sumPrepayed: 0,
  };

  useEffect(() => {
    getListAsync();
  }, [pagination]);

  const getListAsync = async () => {
    const startDateTime = moment(pagination.startDate).format(dateTimeFormat);
    let endDateTime = moment(pagination.endDate).format(dateTimeFormat);
    const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');

    try {
      if (kind == 1) {
        const res = await httpPost(httpUrl.getFrStat, [], {
          endDate: endDateTime,
          kind,
          startDate: startDateTime,
        });

        if (res.result !== 'SUCCESS') {
          setList([]);
          setTotal(0);
          // console.log(`getListAsync failed. result: ${res.result}`);
          return;
        }

        // console.log(res.data.frStatHourlyList);

        setList(
            res.data.frStatHourlyList.slice(
                (pagination.current - 1) * pagination.pageSize,
                (pagination.current - 1) * pagination.pageSize +
                pagination.pageSize
            )
        );
        setTotal(res.data.frStatHourlyList.length);
        // if (liveStatCount > 0) {
        //   const res = await httpPost(httpUrl.getFrStat, [], {
        //     endDate: endDateTime,
        //     kind,
        //     startDate: startDateTime,
        //   });
        //
        //   if (res.result !== 'SUCCESS') {
        //     setList([]);
        //     setTotal(0);
        //     return;
        //   }
        //
        //   setList(res.data.frStatHourlyList);
        //   setTotal(res.data.frStatHourlyList.length);
        // } else {
        //   endDateTime = moment(endDateTime)
        //     .add(1, 'day')
        //     .format(dateTimeFormat);
        //   const res = await httpPost(httpUrl.getFrStat, [], {
        //     endDate: endDateTime,
        //     kind,
        //     startDate: startDateTime,
        //   });
        //
        //   if (res.result !== 'SUCCESS') {
        //     setList([]);
        //     setTotal(0);
        //     // console.log(`getListAsync failed. result: ${res.result}`);
        //     return;
        //   }
        //
        //   // console.log(res.data.frStatHourlyList);
        //
        //   setList(
        //     res.data.frStatHourlyList.slice(
        //       (pagination.current - 1) * pagination.pageSize,
        //       (pagination.current - 1) * pagination.pageSize +
        //         pagination.pageSize
        //     )
        //   );
        //   setTotal(res.data.frStatHourlyList.length);
        // }
      } else {
        const res = await httpPost(httpUrl.getFrStat, [], {
          endDate: endDateTime,
          kind,
          startDate: startDateTime,
        });

        if (res.result !== 'SUCCESS') {
          setList([]);
          setTotal(0);
          // console.log(`getListAsync failed. result: ${res.result}`);
          return;
        }

        setList(
          res.data.frStatHourlyList.slice(
            (pagination.current - 1) * pagination.pageSize,
            (pagination.current - 1) * pagination.pageSize + pagination.pageSize
          )
        );
        setTotal(res.data.frStatHourlyList.length);
      }
    } catch (e) {
      setList([]);
      setTotal(0);
      console.warn('getListAsync failed. ' + e);
    }
  };

  const onCheckList = (id) => {
    var selectedList = selectCategory;
    if (selectCategory.includes(id)) {
      setSelectCategory(selectedList.filter((x) => x !== id));
    } else {
      setSelectCategory([...selectedList, id]);
    }
  };

  const onChange = (page) => {
    setPagination({
      ...pagination,
      current: page,
    });
  };

  const onChangeDatePickerStart = (_, dateString) => {
    if (dateString) {
      if (new Date(pagination.endDate) - new Date(dateString) > 0) {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
        });
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: pagination.endDate,
          endDate: dateString,
        });
      }
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-3, 'M'),
        endDate: now,
      });
    }
  };

  const onChangeDatePickerEnd = (_, dateString) => {
    if (dateString) {
      if (new Date(pagination.startDate) - new Date(dateString) < 0) {
        setPagination({
          ...pagination,
          current: 1,
          endDate: dateString,
        });
      } else {
        setPagination({
          ...pagination,
          current: 1,
          startDate: dateString,
          endDate: pagination.startDate,
        });
      }
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-3, 'M'),
        endDate: now,
      });
    }
  };

  const onChangeRangePicker = (_, dateString) => {
    // const startDate = dateString[0];
    // const endDate = dateString[1];
    if (dateString[0]) {
      setPagination({
        ...pagination,
        current: 1,
        startDate: dateString[0],
        endDate: dateString[1],
      });
    } else {
      setPagination({
        ...pagination,
        current: 1,
        startDate: moment(now).add(-6, 'M'),
        endDate: now,
      });
    }
  };

  const onChangeKindType = (kindType) => {
    setKind(kindType);
    setPagination({
      ...pagination,
      current: 1,
    });
  };

  const onDownload = async () => {
    //const startDate = moment(pagination.startDate).format(dateFormat);
    //const endDate = moment(pagination.endDate).add(1, "day").format(dateFormat);
    const startDateTime = moment(pagination.startDate).format(dateTimeFormat);
    let endDateTime = moment(pagination.endDate).format(dateTimeFormat);
    const userInfo = reactLocalStorage.getObject(Const.appName + '#userinfo');
    let liveStatCount = 0;
    if (
      moment(pagination.endDate).isSameOrAfter(moment(now2).format(dateFormat))
    ) {
      liveStatCount = 1;
    }

    if (kind == 1) {
      if (liveStatCount > 0) {
        const res = await httpPost(httpUrl.getFrStat, [], {
          endDate: endDateTime,
          kind,
          startDate: startDateTime,
        });
        if (res.result !== 'SUCCESS') {
          Modal.error({
            title: '엑셀 다운로드 오류',
            content: (
              <div>
                엑셀로 저장하는 동안 오류가 발생했습니다. 다시 시도해 주십시오.
              </div>
            ),
            ...modalErrorStyle,
          });
          return;
        }

        const title = '통계';
        const filename =
          moment().format('YYYYMMDDhhmmss') + '_' + title + '.xlsx';
        const sheetName = ' 일별';

        const jsonData = res.data.frStatHourlyList.map((row) => ({
          statDateStr: row.statDateStr,
          cntOrderAll: row.cntOrderAll,
          cntOrderCompleted: row.cntOrderCompleted,
          cntPaymentAll: row.cntPaymentAll,
          cntPaymentCompleted: row.cntPaymentCompleted,
          sumDeliveryPrice: row.sumDeliveryPrice,
          sumOrderPrice: row.sumOrderPrice,
          cntCard: row.cntCard,
          sumCard: row.sumCard,
          cntCash: row.cntCash,
          sumCash: row.sumCash,
          cntPrepayed: row.cntPrepayed,
          sumPrepayed: row.sumPrepayed,
        }));

        const array = dailyHeader.concat(jsonData);

        var ws = XLSX.utils.json_to_sheet(array, { skipHeader: true });
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
        XLSX.writeFile(wb, filename);
      } else {
        endDateTime = moment(endDateTime).add(1, 'day').format(dateTimeFormat);
        const res = await httpPost(httpUrl.getFrStat, [], {
          endDate: endDateTime,
          kind,
          startDate: startDateTime,
        });
        if (res.result !== 'SUCCESS') {
          Modal.error({
            title: '엑셀 다운로드 오류',
            content: (
              <div>
                엑셀로 저장하는 동안 오류가 발생했습니다. 다시 시도해 주십시오.
              </div>
            ),
            ...modalErrorStyle,
          });
          return;
        }

        const title = '통계';
        const filename =
          moment().format('YYYYMMDDhhmmss') + '_' + title + '.xlsx';
        const sheetName = ' 일별';

        const jsonData = res.data.frStatHourlyList.map((row) => ({
          statDateStr: row.statDateStr,
          cntOrderAll: row.cntOrderAll,
          cntOrderCompleted: row.cntOrderCompleted,
          cntPaymentAll: row.cntPaymentAll,
          cntPaymentCompleted: row.cntPaymentCompleted,
          sumDeliveryPrice: row.sumDeliveryPrice,
          sumOrderPrice: row.sumOrderPrice,
          cntCard: row.cntCard,
          sumCard: row.sumCard,
          cntCash: row.cntCash,
          sumCash: row.sumCash,
          cntPrepayed: row.cntPrepayed,
          sumPrepayed: row.sumPrepayed,
        }));

        const array = dailyHeader.concat(jsonData);

        var ws = XLSX.utils.json_to_sheet(array, { skipHeader: true });
        var wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, sheetName);
        XLSX.writeFile(wb, filename);
      }
    } else {
      const res = await httpPost(httpUrl.getFrStat, [], {
        endDate: endDateTime,
        startDate: startDateTime,
        kind,
      });
      if (res.result !== 'SUCCESS') {
        Modal.error({
          title: '엑셀 다운로드 오류',
          content: (
            <div>
              엑셀로 저장하는 동안 오류가 발생했습니다. 다시 시도해 주십시오.
            </div>
          ),
          ...modalErrorStyle,
        });
        return;
      }

      const title = '통계';
      const filename =
        moment().format('YYYYMMDDhhmmss') + '_' + title + '.xlsx';
      const sheetName = ' 월별';

      const jsonData = res.data.frStatHourlyList.map((row) => ({
        statMonthStr: row.statMonthStr,
        cntOrderAll: row.cntOrderAll,
        cntOrderCompleted: row.cntOrderCompleted,
        cntPaymentAll: row.cntPaymentAll,
        cntPaymentCompleted: row.cntPaymentCompleted,
        sumDeliveryPrice: row.sumDeliveryPrice,
        sumOrderPrice: row.sumOrderPrice,
        cntCard: row.cntCard,
        sumCard: row.sumCard,
        cntCash: row.cntCash,
        sumCash: row.sumCash,
        cntPrepayed: row.cntPrepayed,
        sumPrepayed: row.sumPrepayed,
      }));

      const array = monthlyHeader.concat(jsonData);

      var ws = XLSX.utils.json_to_sheet(array, { skipHeader: true });
      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, sheetName);
      XLSX.writeFile(wb, filename);
    }
  };

  const skinType = Const.skinType.toUpperCase();
  return (
    <>
      <div className="calculate-adjustment-element">
        <div className="calculate-adjustment-element-menu">
          <div className="calculate-adjustment-element-menu-all">
            <div className="calculate-adjustment-element-menu-all">
              {/* <div className="calculate-element-menu-check useList-check">
                <div
                  className="calculate-element-menu-check-sub"
                  onClick={() => {
                    setSelectOpen(!selectOpen);
                  }}
                >
                  <div
                    className={
                      selectOpen
                        ? "calculate-element-menu-check-all-color"
                        : "calculate-element-menu-check-all"
                    }
                  >
                    분류선택
                    <img
                      src={
                        selectOpen
                          ? require("../../img/body/select.png").default
                          : require("../../img/body/unselect.png").default
                      }
                      alt=""
                      className="select-img2"
                    />
                  </div>
                </div>
                {selectOpen && (
                  <div className="calculate-element-menu-check-menu">
                    {Object.keys(categoryCode).map((key) => (
                      <div key={key}>
                        <div className="all-category-box">
                          <div
                            className={
                              selectCategory.includes(key)
                                ? "calculate-element-menu-check-element"
                                : "calculate-element-menu-check-element2"
                            }
                            onClick={() => onCheckList(key)}
                          >
                            <div className="all-category">
                              {categoryCode[key]}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div> */}

              <div
                className="calculate-adjustment-element-menu-btn mobileoff"
                onClick={() => {}}>
                <Button className="excel" onClick={() => onDownload()}>
                  엑셀 다운로드 &nbsp;
                  <img
                    style={{ display: 'inline' }}
                    src={image.DownloadIcon}
                    className="download-img"
                    alt=""
                  />
                </Button>
              </div>
            </div>
          </div>
          <div className="calculate-adjustment-element-menu-all cal-adj2">
            <div className="delivery-element-menu-text2 text2-sub2">
              기간조회
            </div>
            <div className="calculate-adjustment-content-date">
              <DatePicker
                className="desk"
                placeholder={'시작일'}
                locale={locale}
                style={{
                  height: '50px',
                  borderRadius: '10px',
                  marginTop: '-5px',
                }}
                size="large"
                format={dateFormat}
                value={moment(pagination.startDate, dateFormat)}
                onChange={onChangeDatePickerStart}
                inputReadOnly
                showToday={false}
              />
              <DatePicker
                className="desk"
                placeholder={'종료일'}
                locale={locale}
                style={{
                  height: '50px',
                  borderRadius: '10px',
                  marginTop: '-5px',
                }}
                size="large"
                format={dateFormat}
                value={moment(pagination.endDate, dateFormat)}
                onChange={onChangeDatePickerEnd}
                inputReadOnly
                showToday={false}
              />
              {/* <RangePicker
                className="desk"
                locale={locale}
                style={{
                  marginLeft: "10px",
                  height: "50px",
                  borderRadius: "10px",
                  marginTop: "-5px",
                }}
                size="large"
                format={dateFormat}
                value={[
                  moment(pagination.startDate, dateFormat),
                  moment(pagination.endDate, dateFormat),
                ]}
                onChange={onChangeRangePicker}
              /> */}
              <DatePicker
                className="pos"
                placeholder={'시작일'}
                locale={locale}
                style={{
                  height: '40px',
                  borderRadius: '10px',
                  marginTop: '-5px',
                }}
                size="middle"
                format={dateFormat}
                value={moment(pagination.startDate, dateFormat)}
                onChange={onChangeDatePickerStart}
                inputReadOnly
                showToday={false}
              />
              <DatePicker
                className="pos"
                placeholder={'종료일'}
                locale={locale}
                style={{
                  height: '40px',
                  borderRadius: '10px',
                  marginTop: '-5px',
                }}
                size="middle"
                format={dateFormat}
                value={moment(pagination.endDate, dateFormat)}
                onChange={onChangeDatePickerEnd}
                inputReadOnly
                showToday={false}
              />
              {/* <RangePicker
                className="pos"
                locale={locale}
                style={{
                  marginLeft: "10px",
                  height: "40px",
                  borderRadius: "10px",
                  marginTop: "-5px",
                }}
                size="middle"
                format={dateFormat}
                value={[
                  moment(pagination.startDate, dateFormat),
                  moment(pagination.endDate, dateFormat),
                ]}
                onChange={onChangeRangePicker}
              /> */}
            </div>

            <div
              className={kind === defKindType.daily && skinType === "GOGOIT" ?
                  'gogoit-delivery-element-menu-text3 active':
                  skinType === "GOGOIT" ? 'gogoit-delivery-element-menu-text3' :
                      kind === defKindType.daily
                          ? 'delivery-element-menu-text3 active'
                          : 'delivery-element-menu-text3'
              }
              onClick={() => onChangeKindType(defKindType.daily)}>
              일별통계
            </div>
            <div className="calculate-adjustment-element-menu-line" />
            <div
              className={kind === defKindType.monthly && skinType === "GOGOIT" ?
                  'gogoit-delivery-element-menu-text3 active':
                  skinType === "GOGOIT" ? 'gogoit-delivery-element-menu-text3' :
                      kind === defKindType.monthly
                          ? 'delivery-element-menu-text3 active'
                          : 'delivery-element-menu-text3'
              }
              onClick={() => onChangeKindType(defKindType.monthly)}>
              월별통계
            </div>
          </div>
        </div>

        <div className="calculate-element-sub">
          <div className="deliveryStatic-element-all">
            <div className="deliveryStatic-element-block">
              <div className="deliveryStatic-element-block-menu">
                <div className="deliveryStatic-element-block-menu-text deliveryStatic1">
                  일시
                </div>
                <div className="deliveryStatic-element-block-menu-text">
                  총건수
                </div>
                <div className="deliveryStatic-element-block-menu-text">
                  총완료건수
                </div>
                {/* <div className="deliveryStatic-element-block-menu-text">
                  총결제건수
                </div>
                <div className="deliveryStatic-element-block-menu-text">
                  총완료결제건수
                </div> */}
                <div className="deliveryStatic-element-block-menu-text use3">
                  총배달금액
                </div>
                <div className="deliveryStatic-element-block-menu-text use5">
                  총주문금액
                </div>
                <div className="deliveryStatic-element-block-menu-text use6">
                  카드건수
                </div>
                <div className="deliveryStatic-element-block-menu-text use7">
                  카드금액
                </div>
                <div className="deliveryStatic-element-block-menu-text use8">
                  현금건수
                </div>
                <div className="deliveryStatic-element-block-menu-text use8">
                  현금금액
                </div>
                <div className="deliveryStatic-element-block-menu-text use8">
                  선결건수
                </div>
                <div className="deliveryStatic-element-block-menu-text use9">
                  선결금액
                </div>
              </div>
            </div>

            {(!list || list.length) === 0 && (
              <div style={{ textAlign: 'center', padding: '50px' }}>
                내역이 없습니다.
              </div>
            )}
            {list &&
              list.map((row, index) => (
                <div
                  key={index}
                  className={
                    'deliveryStatic-element-block-field' +
                    (index % 2 === 0 ? '' : ' odd')
                  }>
                  <div className={"deliveryStatic-element-block-field-text" + (skinType === "GOGOIT" ? " gogoit-deliveryStatic-sub1" : " deliveryStatic-sub1")}>
                    <div>
                      {kind === defKindType.daily
                        ? row.statDateStr
                        : row.statMonthStr}
                    </div>
                  </div>
                  <div className="deliveryStatic-element-block-field-text use-sub2">
                    {row.cntOrderAll}
                  </div>
                  <div className="deliveryStatic-element-block-field-text use-sub2">
                    {row.cntOrderCompleted}
                  </div>
                  {/* <div className="deliveryStatic-element-block-field-text use-sub2">
                    {row.cntPaymentAll}
                  </div>
                  <div className="deliveryStatic-element-block-field-text use-sub2">
                    {row.cntPaymentCompleted}
                  </div> */}
                  <div className="deliveryStatic-element-block-field-text use-sub3">
                    {comma(row.sumDeliveryPrice)}
                  </div>
                  {/* <div className="useList-element-block-field-text use-sub4">
                    {comma(row.deliveryPrice)}
                  </div> */}
                  <div className="deliveryStatic-element-block-field-text use-sub5">
                    {comma(row.sumOrderPrice)}
                  </div>
                  <div className="deliveryStatic-element-block-field-text use-sub6">
                    {row.cntCard}
                  </div>
                  <div className="deliveryStatic-element-block-field-text use-sub7">
                    {comma(row.sumCard)}
                  </div>
                  <div className="deliveryStatic-element-block-field-text use-sub8">
                    {row.cntCash}
                  </div>
                  <div className="deliveryStatic-element-block-field-text use-sub8">
                    {comma(row.sumCash)}
                  </div>
                  <div className="deliveryStatic-element-block-field-text use-sub8">
                    {row.cntPrepayed}
                  </div>
                  <div className="deliveryStatic-element-block-field-text use-sub9">
                    {comma(row.sumPrepayed)}
                  </div>
                </div>
              ))}
          </div>

          <div className="deliveryStatic-element-btn mobileoff">
            <Pagination
              current={pagination.current}
              total={total}
              pageSize={pagination.pageSize}
              pagedListSize={PagedListSize}
              onChange={onChange}
            />
          </div>
        </div>
      </div>
    </>
  );
};
export default DeliveryStatic;
